/*
    Filter for choosing which starter sheet records to display,
    based on location, route, run, lane, starter, and time range

    If the user has previously submitted filter values for this report
    during this session, those will be set on load
*/

import React from "react";

import MainContext from "../MainContext";

import LocationDropDown from "../Components/LocationDropDown";
import DateInput from "../Components/DateInput";
import TimeInput from "../Components/TimeInput";
import StyledCheckbox from "../Components/StyledCheckbox";
import MultiSelect from "../Components/MultiSelect";

import { getRoutes, getLanes, getRuns, getStarters } from "../Requests/UtilityRequests";

/*
Location
Route (multi)
Run (multi)
Employee (multi)
Platform/Gate (multi)
Start DateTime
End DateTime
Show All Trips (check)
Driver Reassigned (check)
Starter Reassigned (check) (true)
*/

//
// initial state and the value to return to upon reset
//
function getDefaultState() {
    return {
        location: "",
        startDate: new Date(),
        endDate: new Date(),
        startTime: "00:00",
        endTime: "23:59",
        showAllTrips: false,
        routes: [],
        routesSelected: [],
        runs: [],
        runsSelected: [],
        employees: [],
        employeeSelected: "-1",
        lanes: [],
        lanesSelected: [],
        runs: [],
        runsSelected: []
    };
}

export default class ReportStarterFilter extends React.Component {

    static contextType = MainContext;

    state = getDefaultState();

    //
    //
    updateValue = (evt) => {
        const targetName = evt.target.name;
        this.setState({[targetName]: evt.target.value}, () => {
            if(targetName === "location"){
                this.locationSelected();
            }
        });
    }

    //
    //
    applyFilter = () => {
        const values = {...this.state};

        this.props.applyFilter(values, this.props.toggleFilter);
        this.context.updateReportFilter(values);
    }

    //
    //
    resetFilter = () => {
        this.setState(getDefaultState());
    }

    //
    // when a location is selected, cascade to fill routes, runs, lanes, and starters
    //
    locationSelected = () => {
        this.fillRoutes();
        this.fillRuns();
        this.fillLanes();
        this.fillStarters();
    }
    
    //
    // when route is selected, cascade to fill runs and lanes 
    //
    routeSelected = () => {
        this.fillRuns();
        this.fillLanes();
    }

    //
    // when run is selected, cascade to fill lanes
    //
    runsSelected = () => {
        this.fillLanes();
    }

    //
    //
    fillRoutes = () => {
        const request = () => getRoutes(this.state.location);
        const then = ({data}) => {
            const cleaned = data.map(v => v.Route);
            this.setState({routes: cleaned, routesSelected: []});
        };
        this.context.runProcessing(request, then, "getRoutes");
    }

    //
    //
    fillRuns = () => {
        console.log("RUNS", this.state);
        const request = () => getRuns({
            location: this.state.location, 
            route: this.state.routesSelected.join(",")
        });
        const then = ({data}) => {
            console.log("RUN DATA IN RETURN", data);
            const cleaned = data.map(v => v.Run);
            cleaned.unshift("None");
            this.setState({runs: cleaned, runsSelected: []});
        };
        this.context.runProcessing(request, then, "getRuns");
    }

    //
    //
    fillLanes = () => {
        const request = () => getLanes({
            location: this.state.location, 
            route: this.state.routesSelected.join(","), 
            runId: this.state.runsSelected.join(",")
        });
        const then = ({data}) => {
            const cleaned = data.map(v => v.laneGate);
            cleaned.unshift("None");
            this.setState({lanes: cleaned, lanesSelected: []});
        };
        this.context.runProcessing(request, then, "getLanes");
    }

    //
    //
    fillStarters = () => {
        getStarters(this.state.location)
        .then(({data}) => {
            const cleaned = data.map((starter) => {return {id: starter.employeeid, name: `${starter.firstname} ${starter.lastname}`}});
            this.setState({employees: cleaned, employeeSelected: "-1"});
        });
    }

    //
    // set the filter values
    //
    componentDidMount(){
        console.log("REPORT STARTER FILTER MOUNT", this.context);
        if(this.props.filterValues){
            this.setState({...this.props.filterValues});
        }
        else if(this.context.reportFilterValues){
            console.log("WE HAVE REPORT VALUES", this.context.reportFilterValues);
            const copy = {...this.state};
            for(let key in copy) {
                if(this.context.reportFilterValues.hasOwnProperty(key)){
                    copy[key] = this.context.reportFilterValues[key];
                }
            }

            this.setState(copy);
        }

        // this.fillStarters();
    }

    render(){

        console.log("USERS", this.state.employees);

        const isBus = this.context.user.groupid === "BUS";

        return (
            <div className="filter">
                <div className="form-element-horizontal" id="starter_sheet_location">
                    <label>Location</label>
                    <LocationDropDown
                        setFocus={true}
                        selected={this.state.location} 
                        updateValue={this.updateValue}
                        hasAllOption={true} />
                </div>
                <div className="form-element-horizontal" id="starter_sheet_startdate">
                    <label>Start Date</label>
                    <div>
                        <DateInput 
                            name="startDate"
                            value={this.state.startDate}
                            onChange={this.updateValue}
                        />
                        <TimeInput name="startTime" value={this.state.startTime} onChange={this.updateValue} />
                    </div>
                </div>
                <div className="form-element-horizontal" id="starter_sheet_enddate">
                    <label>End Date</label>
                    <div>
                        <DateInput 
                            name="endDate"
                            value={this.state.endDate}
                            onChange={this.updateValue}
                        />
                        <TimeInput name="endTime" value={this.state.endTime} onChange={this.updateValue} />
                    </div>
                </div>
                <div className="form-element-row" style={{
                    display: "flex",
                    justifyContent: "center"
                }}>
                    <StyledCheckbox 
                        name="showAllTrips" 
                        label="Show All Trips" 
                        checked={this.state.showAllTrips} 
                        onChange={() => this.setState({showAllTrips: !this.state.showAllTrips})} 
                    />
                </div>
                {
                    isBus
                    ? <div className="form-element-horizontal">
                        <label>Routes</label>
                        <MultiSelect 
                            name="routesSelected"
                            options={this.state.routes}
                            selected={this.state.routesSelected}
                            onChange={this.updateValue}
                            dataColumns={8}
                            onDone={this.routeSelected}
                            hasAllOption={true}
                        />
                    </div>
                    : null
                }
                <div className="form-element-horizontal">
                    <label>Runs</label>
                    <MultiSelect 
                        name="runsSelected"
                        options={this.state.runs}
                        selected={this.state.runsSelected}
                        onChange={this.updateValue}
                        dataColumns={8}
                        onDone={this.runsSelected}
                        hasAllOption={true}
                    />
                </div>
                <div className="form-element-horizontal">
                    <label>Employee</label>
                    {
                        this.state.location === ""
                        ? <> 
                            ...
                        </>
                        : <>
                            <select style={{width: "30vw"}} name="employeeSelected" value={this.state.employeeSelected} onChange={this.updateValue}>
                                <option value="-1">Select an Employee</option>
                                {
                                    this.state.employees.map((emp, index) => {
                                        return <option key={` emp_${index}`} value={emp.id}>{emp.name}</option>
                                    })
                                }
                            </select>
                        </>
                    }
                </div>
                {
                    isBus
                    ? <div className="form-element-horizontal">
                        <label>Lanes</label>
                        <MultiSelect 
                            name="lanesSelected"
                            options={this.state.lanes}
                            selected={this.state.lanesSelected}
                            onChange={this.updateValue}
                            dataColumns={8}
                            hasAllOption={true}
                        />
                    </div>
                    : null
                }
                <div className="filter-bar">
                    <div className="option  " onClick={this.resetFilter}>Reset</div>
                    <div className="option  " onClick={this.applyFilter}>Apply Filter</div>
                </div>
            </div>
        )
    }
}